<script lang="ts" setup>
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { ChartBarIcon } from 'tir-style-system/icons/outline';
import { PopoverColorEnum, PopoverPositionEnum, TirPmPopover } from 'tir-components';
import {
  TaskParameter,
  TaskParameterModel,
  TaskParameterTypeEnum,
} from '@/components/task-parameter';

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
  /**Укороченная информация */
  shortInfoParameter: { type: Boolean, default: false },
});

const difficulty = computed(() => {
  return new TaskParameterModel({
    Id: props.task.Difficulty.DifficultyId,
    Name: props.task.Difficulty.DifficultyName,
    Color: props.task.Difficulty.DifficultyColor,
  });
});
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <TaskParameter
      v-if="task.Difficulty"
      preview
      hideRemove
      :shortInfoParameter="shortInfoParameter"
      :isEditing="false"
      :type="TaskParameterTypeEnum.Difficulty"
      :data="difficulty"
    />
    <p v-else class="absence-value">-</p>
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped>
.absence-value {
  font-size: 1.5625rem;
}
.task__popover-title {
  padding: 1rem;
  font-size: 0.75rem;
}
</style>
